var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal as BaseModal, Stack } from "native-base";
import { isWeb } from "@madmedical/utils";
const ModalContent = (_a) => {
    var { children, header, footer, bodyProps } = _a, rest = __rest(_a, ["children", "header", "footer", "bodyProps"]);
    return (_jsxs(_Fragment, { children: [header && (_jsx(BaseModal.Header, Object.assign({ bgColor: "white" }, rest, { children: header }))), _jsx(BaseModal.Body, Object.assign({ bgColor: "white", _scrollview: {
                    _contentContainerStyle: isWeb
                        ? {
                            style: {
                                height: "full",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                            },
                        }
                        : {},
                } }, bodyProps, { children: children })), footer && (_jsx(BaseModal.Footer, Object.assign({ bgColor: "white" }, { children: _jsx(Stack, Object.assign({ direction: "row", space: 2 }, { children: footer })) })))] }));
};
export default ModalContent;
